import { useState } from 'react';

function probeWebGL(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    const canvas = document.createElement('canvas');
    const gl =
      canvas.getContext('webgl2') ||
      canvas.getContext('webgl') ||
      canvas.getContext('experimental-webgl');
    return Boolean(gl);
  } catch {
    return false;
  }
}

/** True if the browser can create a WebGL context (probed once). */
export function useWebGLSupport(): boolean {
  const [supported] = useState(probeWebGL);
  return supported;
}
